import { useMutation } from "@tanstack/react-query";
import axiosClient from "../../lib/axiosClient";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { CreditCardIcon } from "lucide-react";

interface Props {
  id: string;
}

export default function PayerPetiteAnnonceButton({ id }: Props) {
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await axiosClient.post<string>(`/petites-annonces/${id}/stripe-session`);
      const sessionId = response.data;
      const stripe = await loadStripe(`${import.meta.env.VITE_STRIPE_KEY}`);
      await stripe?.redirectToCheckout({ sessionId });
    },
    onError: (error: any) => {
      console.error(error);
      toast.error(error.response?.data?.message || "Une erreur est survenue lors du paiement");
    },
  });

  return (
    <Button
      icon={<CreditCardIcon size={16} />}
      variant='default'
      onClick={() => mutation.mutate()}
      loading={mutation.isPending}
      disabled={mutation.isPending}
    >
      Payer
    </Button>
  );
}
